import { ConnectionsClient } from "../Models/Api/strongbox.client";
import { ConnectionRequestDescriptor, ConnectionRequestParameters } from "../Models/Api/strongbox.models";
import { StrongboxConnectionDescriptor } from "../Utils/ConnectStrongbox";

export class OrganizationsService {

    public async StartGetFinancialsConnectionDescriptor(connectionInfo: StrongboxConnectionDescriptor): Promise<ConnectionRequestDescriptor> {
        const connections = new ConnectionsClient(connectionInfo.delegatedAccessToken, connectionInfo.strongboxUri);

        let parameters: { [key: string]: string; } | undefined = undefined;

        if (connectionInfo.sourceFlow === 'borrower') {
            parameters = {
                mode: 'borrower'
            }
        }

        const requestParameters = new ConnectionRequestParameters({
            datasourceNameId: connectionInfo.accountingPackage.nameId,
            parameters
        });
        const response = await connections.createRequest(
            connectionInfo.orgId,
            requestParameters,
        );

        if (!this.goodResponse(response.status)) {
            throw new Error("Bad Response");
        }

        return response.result;
    }

    goodResponse(status: number): boolean {
        return status === 200 || status === 201 || status === 204;
    }
}